import { ReportColumnConfig } from 'components/ReportGrid_New/types';
import { formatDateTime } from 'utils/helpers';

export const reportHeaderTagLine = `Report produced on ${formatDateTime(new Date())}`;

export const ACTIVEWEB_USAGE_REPORT = 'Activeweb Usage Report V2';

export const ACTIVEWEB_USAGE_REPORT_MESSAGE =
  'This report provides usage statistics for all registered ActiveWeb users within your company. It provides filtering for both Active and Inactive accounts.';

export const ACTIVEWEB_USAGE_REPORT_GRID_TITLE = 'activeWebUsageReportV2';

export const selectOptions = [
  { id: 1, text: 'All Accounts', value: '-1' },
  { id: 2, text: 'Live Accounts', value: '0' },
  { id: 3, text: 'Expired Accounts', value: '1' },
];

const month = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const date = new Date();
const previousMonth = month[date.getMonth() == 0 ? 11 : date.getMonth() - 1];
const previousMonthMinusOneIndex = (date.getMonth() + 10) % 12;
const previousMonthMinusOne = month[previousMonthMinusOneIndex];
const previousMonthMinusTwoIndex = (date.getMonth() + 9) % 12;
const previousMonthMinusTwo = month[previousMonthMinusTwoIndex];
const currentYear = date.getFullYear();
const previousYear = date.getFullYear() - 1;

export const columns: ReportColumnConfig[] = [
  { name: 'fullName', title: 'Full Name' },
  { name: 'profile', title: 'Profile' },
  { name: 'lastused', title: 'Last Used', type: 'date' },
  {
    name: 'searchesPriorMonthMinus1',
    title: `${previousMonthMinusTwo} ${
      date.getMonth() == 0 || date.getMonth() == 1 || date.getMonth() == 2
        ? previousYear
        : currentYear
    } searches`,
    type: 'number',
  },
  {
    name: 'searchesPriorMonth',
    title: `${previousMonthMinusOne} ${
      date.getMonth() == 0 || date.getMonth() == 1 ? previousYear : currentYear
    } searches`,
    type: 'number',
  },
  {
    name: 'searchesThisMonth',
    title: `${previousMonth} ${
      date.getMonth() == 0 ? previousYear : currentYear
    } searches`,
    type: 'number',
  },
  {
    name: 'ytdSearchCount',
    title: `Searches ${date.getMonth() == 0 ? previousYear : currentYear} YTD`,
    type: 'number',
  },
  { name: 'feedbackCount', title: 'Feedback Count', type: 'number' },
  {
    name: 'accountLockedDate',
    title: 'Account Locked',
  },
  {
    name: 'disabled',
    title: 'Account Expired',

  },
];

